import { Fragment, useEffect, useState } from 'react';
import { Text } from '../../FormControls/Text';
import { List } from '../../FormControls/List';
import { Stack } from '../../FormControls/Stack';

import { ScreenControl } from '../ScreenControl';

import { useDispatch, useSelector } from 'react-redux';
import { retrieveCryptos, setCrypto } from '../../../../main/slices/blockchainSlice';
import { LoadingComponent } from '../../LoadingComponent';

export const CryptoSelector = () => {

    const [cryptos, setCryptos] = useState([]);
    const state = useSelector(({ blockchain }) => blockchain.crypto);
    const dispatch = useDispatch();

    useEffect(() => {

        dispatch(retrieveCryptos()).unwrap().then(({ response, statusCode }) => {
            if (statusCode === 200) setCryptos(response);
        }).catch((e) => false)

    }, [dispatch]);

    return (
        <Fragment>

            <Stack flex={{ flexDirection: "column" }}>
                <Text classes={["subtitle"]}> Agreguemos tu wallet </Text>
                <Text classes={["title"]}> Selecciona una crypto </Text>
            </Stack>

            {cryptos.length ?
                <List
                    items={cryptos}
                    def={state.value}
                    keys={{ img: "logo", text: "name", id: "symbol" }}
                    onSelect={(b) => dispatch(setCrypto({ value: b, error: !b }))}
                />
                : <LoadingComponent />
            }

            <ScreenControl disabled={state.error}></ScreenControl>

        </Fragment>
    )
}